import { ThemeOptions } from '@mui/material';
import appTheme from './appTheme';

// Configuration for Material UI theme feature.
// https://mui.com/material-ui/customization/theming/
const theme: ThemeOptions = {
  palette: {
    primary: {
      light: appTheme.themeGreenLight,
      main: appTheme.themeGreen,
      dark: appTheme.greenDark,
      contrastText: appTheme.white,
    },
    secondary: { main: '#33413C' },
    error: {
      light: '#e62d2d',
      main: '#e62d2d',
      dark: '#e62d2d',
      contrastText: appTheme.white,
    },
  },
};

export default theme;
